<template>
    <div class="convert-header" :class="[stage]">
        <div class="text-center title" v-if="showTitle">
            <template v-if="!showResult">
                {{ lbl.convert.title.convert }} {{ blobConfig.appName
                }}<br />
                {{ lbl.convert.title.textTo }} {{ toApp }}
            </template>
            <template v-else> {{ lbl.result.successfully }} </template>
        </div>
        <div class="flex justify-start" style="min-width: 0px">
            <div class="text-center flex-1">
                <div class="logo-wrapper">
                    <img class="mx-auto" :src="blobConfig.appImgUrl" />
                </div>
                <template v-if="hasMode">
                    <div class="info">
                        <div class="point ff-semi leading-none" v-if="mode == 'point'">
                            {{ FilterNumberFormat(pointRaw) }}
                        </div>
                        <div class="name">{{ blobConfig.appName }}</div>
                    </div>
                </template>
            </div>
            <div class="flex-none">
                <img class="arrow-right" :src="blobConfig.arrowUrl" />
            </div>
            <div class="text-center flex-1">
                <div class="logo-wrapper">
                    <img class="mx-auto" src="@/module/Bitkub/assets/logo-bitkub.png" />
                </div>
                <template v-if="hasMode">
                    <div class="info">
                        <div class="point ff-semi leading-none" v-if="mode == 'point'">
                            {{ formatPoint(pointConverted) }}
                        </div>
                        <div class="name">{{ toApp }}</div>
                    </div>
                </template>
            </div>
        </div>

        <template v-if="showCurrentPoint">
            <div class="current-point px-3 text-center">
                <div class="text-15 mb-1">{{ currentPointLabel }}</div>
                <div class="text-25 text-gray leading-none">
                    {{ FilterNumberFormat(points) }}
                </div>
            </div>
            <div class="mt-4 text-center">
                <div>Current Rate {{ lbl.exchangeName }} : {{ currentBalance }} Baht</div>
                <div class="text-13">
                    Time remainaing
                    <span class="text-red">{{ countdownTime }}</span>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Utility from "@/helper/Utility";
import TimerHelper from "@/helper/TimerHelper";

export default {
    name: "ConvertHeader",
    props: {
        lbl: {
            type: Object,
        },
        mode: {
            type: String,
            default: "name", // name, point,
        },
        blobConfig: {
            type: Object,
        },
        showResult: {
            type: Boolean,
            default: false,
        },
        showCurrentPoint: {
            type: Boolean,
            default: false,
        },
        stage: {
            type: String,
        },
        toApp: {
            type: String,
            default: "Bitkub Coin",
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        expiresIn: {
            type: Number,
            default: () => 1 * 60,
        },
        pointRaw: {
            type: Number,
            default: 0
        },
        pointConverted: {
            type: Number,
            default: 0
        }
    },
    components: {},
    inject: ["BitkubStates", "TransferPointStates"],
    mixins: [],
    emits: ["onTranExpire"],
    data: function () {
        return {
            timer: new TimerHelper(),
            isTimeExpired: false,
            countdownTime: '00:00'
        };
    },
    computed: {
        hasMode: function () {
            return !Utility.isEmptyStr(this.mode);
        },
        currentPointLabel: function () {
            return Utility.stringFormat(
                this.lbl.convert.current_point,
                this.blobConfig.appName
            );
        },
        points: function () {
            return this.BitkubStates.userPoints.value;
        },
        transDetail: function () {
            // console.log("refresh trans detail");
            return this.TransferPointStates.resultCheck ?? {};
        },
        currentRate: function () {
            let raw = Math.floor((this.transDetail.rate || 0) * 10000) / 10000
            return Utility.formatNum(raw, 4);
        },
        currentBalance: function () {
            // console.log(this.transDetail)
            let raw = Math.floor((this.transDetail.balance || 0) * 10000) / 10000
            return Utility.formatNum(raw, 4);
        }
    },
    methods: {
        startTimer: function () {
            if (this.timer.interval) {
                this.stopTimer();
            }

            this.timer.initialTimer(this.expiresIn, ":");
            this.isTimeExpired = false;

            this.timer.runTimer((time) => {
                // do nothing
                this.countdownTime = time
            }, () => {
                this.stopTimer();

                this.isTimeExpired = true;
                this.$emit("onTranExpire");
            });
        },
        stopTimer: function () {
            this.timer.resetTimer();
            this.timer.stopTimer();
        },
        formatPoint: function (point, d = 4) {
            // console.log(point)
            return Utility.formatNum(point, d);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";

.convert-header {
    @extend %base-class;
    color: $gray;

    &.init {
        margin-bottom: 50px;
    }

    &.tier {
        margin-bottom: 20px;
    }

    &.result {
        margin-bottom: 40px;

        .title {
            margin-bottom: 36px;
        }
    }

    .info {
        margin-top: 15px;

        .name {
            font-size: 13px;
            color: #aaaaaa;
        }

        .point {
            font-size: 15px;
            font-weight: 600;
        }
    }

    .title {
        font-size: 15px;
        color: $gray;
        margin-bottom: 12px;
    }

    .arrow-right {
        margin-top: 24.5px;
    }

    .logo-wrapper {
        img {
            height: 80px;
            width: 80px;
        }
    }

    .current-point {
        margin-top: 20px;
    }

    .leading-none {
        line-height: 1rem;
    }

    .text-red {
        color: $red;
    }
}
</style>
